'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'sailboat';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M84.8 400l406.4 0-38.4 64-329.6 0L84.8 400z', 'M256 320l272 0L256 0l0 320zM56 352L0 352l28.8 48L96 512l384 0 67.2-112L576 352l-56 0L56 352zm28.8 48l406.4 0-38.4 64-329.6 0L84.8 400zM224 64L48 320l176 0 0-256z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;